var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLib(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28 8a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v1h24zM22 1H10a3 3 0 0 0-2.82 2h17.64A3 3 0 0 0 22 1zM28 11H4a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h24a3 3 0 0 0 3-3V14a3 3 0 0 0-3-3zm-7 11.8-5.75 3.6A2.13 2.13 0 0 1 12 24.59v-7.18a2.13 2.13 0 0 1 3.25-1.81L21 19.2a2.12 2.12 0 0 1 0 3.6z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.94 20.89-5.75-3.59h-.06a.11.11 0 0 0-.07 0 .11.11 0 0 0-.06.11v7.18a.13.13 0 0 0 .19.11l5.75-3.59a.13.13 0 0 0 0-.22z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLib);
export default __webpack_public_path__ + "static/media/lib.c1672133e74262b08625c93fa67f496d.svg";
export { ForwardRef as ReactComponent };